import { useTranslation } from 'react-i18next'

import { Text, Icon, Box, PaginationItem } from '@percent/lemonade'
import classes from './CursorPagination.module.scss'

export interface PaginationProps {
  totalRecords?: number
  nextPage: () => void
  previousPage: () => void
  hasNextPage?: boolean
  hasPreviousPage?: boolean
}

export function CursorPagination({
  nextPage,
  previousPage,
  totalRecords,
  hasNextPage,
  hasPreviousPage
}: PaginationProps) {
  const { t } = useTranslation()

  return (
    <Box className={classes.Wrapper}>
      <Box className={classes.Results}>
        <Text as="span" size="small">
          {totalRecords ? `${t('workplace_giving.pagination.results', { count: totalRecords })}` : ''}
        </Text>
      </Box>
      <Box className={classes.Flex}>
        <PaginationItem disabled={!hasPreviousPage} onClick={() => previousPage()}>
          <Icon name="chevron-left" size="s" />
        </PaginationItem>

        <PaginationItem disabled={!hasNextPage} onClick={() => nextPage()}>
          <Icon name="chevron-right" size="s" />
        </PaginationItem>
      </Box>
    </Box>
  )
}
